import { useEffect, useState } from 'react';
import {
  getCustomers,
  createCustomer,
  updateCustomer,
  deleteCustomer,
  markUserInactive,
  createBulkCustomers,
} from '../service';
// import { CUSTOMER } from '../constants';
import { handleAPIError } from '../../../utils/apiUtils';

const useCustomerState = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const data = await getCustomers();
      setCustomers(data);
    } catch (error) {
      console.error('Failed to fetch customers', error);
      // setCustomers(CUSTOMER);
    } finally {
      setLoading(false);
    }
  };

  const sortAndSetCustomers = (customersList) => {
    customersList.sort((a, b) => {
      if (a.is_active !== b.is_active) {
        return b.is_active - a.is_active;
      }

      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      return 0;
    });
    setCustomers(customersList);
  }

  const addOrUpdate = async (customer) => {
    let response = {
      success: false,
      code: null,
      message: null,
    };

    try {
      if (customer.id) {
        const updated = await updateCustomer(customer.id, customer);
        const updatedCustomers = customers.map(c => (c.id === updated.id ? updated : c));
        sortAndSetCustomers(updatedCustomers);
        response.success = true;
      } else {
        const created = await createCustomer(customer);
        const updatedCustomers = [...customers, created];
        sortAndSetCustomers(updatedCustomers);
        response.success = true;
      }
    } catch (error) {
      response = handleAPIError(error);
      console.error('Failed to add or update customer', error);
    }
    return response;
  };

  const remove = async (id) => {
    try {
      await deleteCustomer(id);
      const updatedCustomers = customers.filter(c => c.id !== id);
      sortAndSetCustomers(updatedCustomers);
    } catch (error) {
      console.error('Failed to delete customer', error);
    }
  };

  const markInactive = async (id, date) => {
    try {
      await markUserInactive(id, date);
      const updatedCustomers = customers.map(c => 
        c.id === id ? { ...c, is_active: !c.is_active, last_deactivation_date: date} : c
      );
      sortAndSetCustomers(updatedCustomers);
    } catch (error) {
      console.error('Failed to mark inactive the customer', error);
    }
  }

  const importCustomers = async(customers) => {
    let response = {
      success: false,
      code: null,
      message: null,
    };
    try {
      const created = await createBulkCustomers(customers);
      if(created) {
        response.success = true;
      }
    } catch (error) {
      response = handleAPIError(error);
      console.error('Failed to add or update customer', error);
    } finally {
      return response;
    }
  }

  useEffect(() => {
    fetchCustomers();
  }, []);

  return { customers, loading, addOrUpdate, remove, markInactive, importCustomers };
};

export default useCustomerState;
